import { GetOrganizationSummaryResponseBodyType } from "@intelligems/ig-types/functions/organization-summaries/get-organization-summary";
import { useQuery } from "@tanstack/react-query";

import { useGetOrg } from "../organizations/get-organization";
import { organizationsKeys } from "../queryKeys";

import { getOrganizationSummary } from "./get-organization-summary";

export const useGetOrganizationSummaryWithLoading = () => {
  const org = useGetOrg();
  return useQuery<GetOrganizationSummaryResponseBodyType>({
    queryKey: organizationsKeys.orgSummary(org.data?.org?.id),
    queryFn: async () => getOrganizationSummary(),
    enabled: !!org.data?.org?.id,
    refetchOnWindowFocus: "always",
  });
};
